import type { Response } from '../extended-express-types';
import { fileElementSchema } from './file-validation';
import { idSchema } from './validation';

// AJVVersion9 JSONSchemaType<number>
export const messageNumberSchema = {
  type: 'integer',
  minimum: 1,
};

export const threadTitleMaxLength = 100;

// AJVVersion9 JSONSchemaType<string>
export const threadTitleSchema = {
  type: 'string',
  minLength: 1,
  maxLength: threadTitleMaxLength,
};

export const messageBodyMaxLength = 10000;

// Schema validated using `JSONSchemaType<MessageSubmit>`
export const messageSchema = {
  type: 'object',
  properties: {
    salt: idSchema,
    body: { type: 'string', minLength: 0, maxLength: messageBodyMaxLength },
    files: {
      type: 'array',
      items: fileElementSchema,
      minItems: 1,
    },
  },
  required: ['salt', 'body'],
  additionalProperties: false,
};

export const getMessageMax = 200;

export function getMessageValidate({
  start,
  end,
  res,
}: {
  start?: number;
  end?: number;
  res: Response;
}) {
  if (typeof start === 'number' && typeof end === 'number') {
    if (start > end) {
      res.status(400);
      throw new Error('start larger than end');
    }
    if (end - start > getMessageMax) {
      res.status(400);
      throw new Error('start larger than end');
    }
  }
}
